// extracted by mini-css-extract-plugin
export default {"settings":"U6Kr9V9jtHLGWI5UJ5YV","icon":"ZirO1DiUdu06XuFUk3a2","active":"G_KktNCCFvDKUnK5csMD"};